<template>
  <base-wrapper :loading="loadingKantorPelayanan || loadingJobStatus">
    <div class="space-y-4">
      <div class="flex items-center justify-end space-x-2">
        <base-input
          type="search"
          placeholder="Cari Kantor Pelayanan"
          debounce
          :shadow="false"
          v-model="filter.search"
          @native-input="loadKantorPelayanan"
        />
        <base-button @click="onCreate" type="button">
          <Icon icon="heroicons:plus-20-solid" class="h-5 w-5" />
          Tambah Kantor Pelayanan
        </base-button>
        <base-button :loading="loadingExport.visible" @click="onExport">
          <Icon
            v-if="!loadingExport.visible"
            icon="heroicons:arrow-down-tray"
            class="h-4 w-4"
          />
          {{ loadingExport.visible ? loadingExport.text : 'Export' }}
        </base-button>
      </div>
      <datatable
        :total="summary.total"
        :perPage="kantorPelayanans.meta.page.perPage"
        :currentPage="currentPage"
        :meta="kantorPelayanans.meta"
        :columns="[
          { id: 'code', name: 'Kode Kantor Pelayanan' },
          { id: 'name', name: 'Nama Kantor Pelayanan' },
          { id: 'area', name: 'Area' },
          { id: 'bank_account_number', name: 'No. Rekening' },
          { id: 'phone', name: 'Alamat / No. Telp' },
        ]"
        cursor
        @pagechanged="onPageChange"
        @prev="currentPage--"
        @next="currentPage++"
      >
        <template #tbody="{ classes }">
          <tr
            v-for="kantorPelayanan in kantorPelayanans.data"
            :key="kantorPelayanan.id"
            :class="[classes.tr, kantorPelayanan.relationships.office.data ? 'cursor-pointer bg-white hover:bg-green-100' : 'bg-white']"
            @click="onClickDetail(kantorPelayanan)"
          >
            <td :class="classes.td">
              <p class="font-bold text-gray-900">
                {{ kantorPelayanan.attributes.code }}
              </p>
            </td>
            <td :class="classes.td">
              <p class="text-gray-900 mb-1">{{ kantorPelayanan.attributes.name }}</p>
              <p class="text-xs">{{ getOfficeIncluded(kantorPelayanan)?.attributes?.email ?? '' }}</p>
            </td>
            <td :class="classes.td">{{ getOfficeIncluded(kantorPelayanan)?.attributes?.area_name ?? '-' }}</td>
            <td :class="classes.td">{{ getOfficeIncluded(kantorPelayanan)?.attributes?.bank_account_number ?? '-' }}</td>
            <td :class="classes.td">
              <div>
                <p>
                  {{ getOfficeIncluded(kantorPelayanan)?.attributes?.full_address ?? '-' }}
                </p>
                <p class="text-xs">
                  {{ getOfficeIncluded(kantorPelayanan)?.attributes?.phone ?? '' }}
                </p>
              </div>
            </td>
          </tr>
        </template>
      </datatable>
    </div>

    <office-form-modal
      office-type="kantor_pelayanan"
      :visible="createModalVisible"
      @close="createModalVisible = false"
      @success="onSuccessCreate"
    />
    <view-office-modal
      office-type="kantor_pelayanan"
      :loading="detailModal.loading"
      :visible="detailModal.visible"
      :office-id="detailModal.officeId"
      @close="detailModal.visible = false"
    />
  </base-wrapper>
</template>

<script>
import BaseButton from '@/components/base/BaseButton.vue';
import ViewOfficeModal from '@/components/office/view-office-modal.vue';
import OfficeFormModal from '@/components/office/office-form-modal.vue';
import { requestMixin } from '@/mixins/request/request';
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';
import { downloadFileUrl } from '../../../../../services/utils.service';

export default {
  name: 'Home',
  mixins: [requestMixin],
  components: {
    BaseButton,
    ViewOfficeModal,
    OfficeFormModal,
  },
  data() {
    return {
      currentPage: 1,
      detailModal: {
        officeId: null,
        visible: false,
        loading: false
      },
      filter: {
        search: null,
      },
      loadingKantorPelayanan: false,
      kantorPelayanans: {
        data: [],
        meta: {
          page: {},
        },
      },
      createModalVisible: false,
      summary: {},
      loadingJobStatus: false,
      loadingExport: {
        visible: false,
        text: null,
      },
    };
  },
  computed: {
    ...mapGetters({
      getChannelName: 'auth/getChannelName',
    }),
  },
  created() {
    this.loadKantorPelayanan();
    this.loadJobStatus();
    this.addListener()
  },
  methods: {
    ...mapActions({
      createAlert: 'alert/createAlert',
    }),
    async onClickDetail(simpleOffice) {
      if (simpleOffice.relationships.office.data) {
        this.detailModal.officeId = simpleOffice.relationships.office.data.id;
        this.detailModal.visible = true;
      }
    },
    getOfficeIncluded(simpleOffice) {
      if (!simpleOffice.relationships.office.data) {
        return null
      }

      return this.getSingleIncluded(
        this.kantorPelayanans,
        simpleOffice.relationships.office.data.id
      );
    },
    onPageChange(page) {
      this.loadKantorPelayanan({
        ...page,
        'filter[with_summary]': false
      });
    },
    onCreate() {
      this.createModalVisible = true;
    },
    onSuccessCreate() {
      this.createModalVisible = false;
      this.loadKantorPelayanan();
    },
    async loadKantorPelayanan(params) {
      this.loadingKantorPelayanan = true;

      const [res, err] = await this.request('/api/v1/offices', {
        params: {
          'page[limit]': 10,
          'filter[office_category_id]': 2,
          include: 'office',
          'fields[simple-offices]': 'code,name,office',
          'fields[offices]': 'full_address,phone,email,area_name,bank_account_number',
          'filter[search]': this.filter.search,
          'filter[with_summary]': true,
          ...params,
        },
      });

      if (!err) {
        this.kantorPelayanans = res;

        if (res.meta.summary) {
          this.summary = res.meta.summary
        }

        if (!params) {
          this.currentPage = 1
        }
      }

      this.loadingKantorPelayanan = false;
    },
    async onExport() {
      this.startLoadingExport('Mengirim ke server');

      const [, err] = await this.request(
        `/api/v1/offices/-actions/export`,
        {
          method: 'post',
          data: {
            office_type: 'kantor_pelayanan'
          }
        }
      );

      if (err) {
        this.createAlert({
          status: 'error',
          data: this.getRequestErrorMessage(err),
        });

        this.stopLoadingExport();
      } else {
        this.startLoadingExport('Sedang diproses');
      }
    },
    onExportProgress(e) {
      if (e.type === 'App\\Notifications\\OfficeExported' && e.office_type === 'kantor_pelayanan') {
        if (e.status === 'failed') {
          this.stopLoadingExport();

          this.createAlert({
            data: 'Gagal mengexport kantor pelayanan',
            status: 'error',
          });
        } else if (e.status === 'success') {
          this.stopLoadingExport();

          downloadFileUrl(e.file_url, 'kantor_pelayanan.csv', { blank: true });
        }
      }
    },
    addListener() {
      const userChannel = this.$pusher.channel(this.getChannelName);

      userChannel.bind(
        'Illuminate\\Notifications\\Events\\BroadcastNotificationCreated',
        this.onExportProgress
      );
    },
    async loadJobStatus() {
      this.loadingJobStatus = true;

      const [res, err] = await this.request(
        '/api/v1/users/-actions/check-job-status',
        {
          params: {
            type: 'export_kantor_pelayanan',
          },
        }
      );

      if (!err) {
        const { running } = res;

        if (running) {
          this.startLoadingExport('Sedang Diproses');
        }
      }

      this.loadingJobStatus = false;
    },
    startLoadingExport(text) {
      this.loadingExport.text = text;
      this.loadingExport.visible = true;
    },
    stopLoadingExport() {
      this.loadingExport.visible = false;
    },
    removeExportListener() {
      const userChannel = this.$pusher.channel(this.getChannelName);

      if (userChannel) {
        userChannel.unbind(
          'Illuminate\\Notifications\\Events\\BroadcastNotificationCreated',
          this.onExportProgress
        );
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    this.removeExportListener();

    next();
  },
};
</script>
